<div class="grid">
  <div class="effects pane list">
    <h2>Effects</h2>
    <app-effect-picker
      id="layer-adder"
      (selectEffect)="addEffectToLayer($event)"
      ></app-effect-picker>
  </div>
  <div class="image pane">
      <!-- [imageData]="imageData$ | async" -->
    <app-render-view
      [renderName]="renderName$ | async"
      [layerOrder]="layerOrder$ | async"
      (renderNameChange)="changeRenderName($event)"
      (resetEditorState)="resetEditorState()"
      ></app-render-view>
  </div>
  <div class="layers pane list">
    <app-layer-list
      id="layer-list"
      [selectedLayerId]="selectedLayer$ | async"
      [layers]="layers$ | async"
      [layerOrder]="layerOrder$ | async"
      (setSelectedLayer)="setSelectedLayer($event)"
      (toggleShowEffects)="toggleShowEffects($event)"
      (toggleLayerVisibility)="toggleLayerVisibility($event)"
      (deleteLayer)="deleteLayer($event)"
      (deleteEffect)="deleteEffect($event)"
      (cloneLayer)="cloneLayer($event)"
      (changeLayerOrder)="changeLayerOrder($event)"
      (selectEffect)="selectEffect($event)"
      (moveLayer)="moveLayer($event)"
      (moveEffect)="moveEffect($event)"
      ></app-layer-list>
  </div>
  <div
    class="properties pane list"
    id="properties"
  >
    <h2>Properties</h2>
    <app-properties-list
      [selectedLayerId]="selectedLayer$ | async"
      [effectsList]="effectsList$ | async"
      [layers]="layers$ | async"
      [selectedEffectId]="selectedEffectId$ | async"
      (updateLayer)="updateLayer($event)"
      (selectEffectId)="selectEffect($event)"
      ></app-properties-list>
  </div>
  <div class="presets pane list" id="presets">
    <div class="header">
      <h2>Presets</h2>
      <div>
        <!-- <p-button pTooltip="Submit Preset" tooltipPosition="bottom" icon="pi pi-crown" [rounded]="true" [text]="true" severity="primary" size='small' /> -->
        @if (!isDemo) {
          <p-button pTooltip="New Preset" tooltipPosition="bottom" icon="pi pi-plus-circle" [rounded]="true" [text]="true" severity="info" size='small' (onClick)="openPresetDialog()"/>
        }
      </div>
    </div>
    <app-preset-list>
    </app-preset-list>
  </div>
</div>
